import shiftRequestDetailsStore from "../../store/store";
import { IMemberEntity } from "sh-models";
import { mutatorAction } from "satcheljs";

export default mutatorAction('SET_RECEIVER_MEMBER', function setReceiverMemberInStore(member: IMemberEntity) {
    if (shiftRequestDetailsStore) {
        shiftRequestDetailsStore.receiverMember = member;
    }
});
